import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useApolloClient, useMutation } from '@apollo/client';
import Button from '../components/Button';
import Global from '../components/Global';
import { Modal, ModalName, ModalPart } from '../components/Modal';
import { getHome } from '../utilities/getHome';
import { LOGOUT } from '../utilities/mutations';

const LogoutModal = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const client = useApolloClient();
  const [logout, { loading }] = useMutation(LOGOUT);

  const close = () => {
    if (location.state?.inApp) {
      navigate(-1);
    } else {
      getHome(navigate);
    }
  };

  if (!localStorage.getItem('token')) {
    return <Navigate to="/login" replace />;
  }

  return (
    <>
      <Global />
      <Modal onClose={() => close()}>
        <ModalName>Log out</ModalName>
        <ModalPart>Are you sure you want to log out?</ModalPart>
        <ModalPart>
          <Button
            disabled={loading}
            onClick={async () => {
              await logout();
              localStorage.removeItem('token');
              client.resetStore();

              if (location.state?.fromPublicSpace) {
                navigate(-1);
              } else {
                getHome(navigate);
              }
            }}
            isPrimary
            isExtended
          >
            Log out
          </Button>
          <Button disabled={loading} onClick={() => close()} isExtended>
            Cancel
          </Button>
        </ModalPart>
      </Modal>
    </>
  );
};

export default LogoutModal;
